import React, { useState, useEffect, useRef } from "react";
import "./ProfileProductInnovation.css";
import TopRightActionLinks from "../../TopRightActionLinks";
import InsightBlock from "../../InsightBlock";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { submitCompetitorProfileV3Request } from "../../../../../store/features/actions/competitorProfileV3Actions";
import {
  submitCompetitorProfileFailure,
  submitCompetitorProfileRequest,
} from "../../../../../store/features/actions/competitorProfileActions";
import {
  getAllSubdimensionMatches,
  getAllPageInsights,
  formatBoldText,
  getCompProfilePageInsights,
  getRnDSpendLineChartData,
  transformPortfolioDataForInsightTable,
  hasData,
} from "../../../../../services/commonService";
import LineChart from "../../../../HtmlElements/LineChart";
import ProductLaunchesAndRelatedActivities from "./ProductLaunchesAndRelatedActivities";
import PatentsAndIpActivity from "./PatentsAndIpActivity";
import InnovationThemeRadar from "./InnovationThemeRadar";
import CompetitivePositionAnalysis from "./CompetitivePositionAnalysis";
import TechnologyCapabilityAssessment from "./TechnologyCapabilityAssessment";
import ValuePropositionAnalysis from "./ValuePropositionAnalysis";
import StrategicRiskMatrix from "./StrategicRiskMatrix";
import InsightTable from "../../InsightTable";
import ProductAndSolutionsPortfolio from "./ProductAndSolutionsPortfolio";
import TotalRAndDSpend from "./TotalRAndDSpend";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";
import APP_CONFIG from "../../../../../config/appConfig";

function ProfileProductInnovation({
  activeSubKey,
  setActiveSubKey,
  compView,
  dataReportCheck,
  scrollTarget,
  marketIqClient,
  clientCompanyType,
}) {
  const summaryRef = useRef(null);
  const productSolutionsRef = useRef(null);
  // const compPositionRef = useRef(null);
  const productLaunchesRef = useRef(null);
  const patentsIpRef = useRef(null);
  const technologyCapabilityRef = useRef(null);
  const customerValuePropositionRef = useRef(null);
  const strategicRiskMatrixRef = useRef(null);
  const rdSpendEstimatesRef = useRef(null);
  const rdFocusRef = useRef(null);
  const innovationThemeRef = useRef(null);
  const programmaticScrollRef = useRef(false);

  const sectionMap = {
    insightSummary: summaryRef,
    productInnovationSolutions: productSolutionsRef,
    // compPosition: compPositionRef,
    productLaunches: productLaunchesRef,
    patentsIp: patentsIpRef,
    technologyCapability: technologyCapabilityRef,
    customerValueProposition: customerValuePropositionRef,
    strategicRiskMatrix: strategicRiskMatrixRef,
    rdSpendEstimates: rdSpendEstimatesRef,
    rdFocus: rdFocusRef,
    innovationTheme: innovationThemeRef,
  };

  const scrollToSection = (key) => {
    const ref = sectionMap[key];
    if (!ref?.current) return;

    programmaticScrollRef.current = true;

    const yOffset = -100;
    const y =
      ref.current.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });

    setTimeout(() => {
      programmaticScrollRef.current = false;
    }, 700);
  };

  // Scroll into view when a subsection tab is clicked
  // useEffect(() => {
  //   if (!activeSubKey) return;
  //   const sectionMap = {
  //     insightSummary: summaryRef,
  //     productInnovationSolutions: productSolutionsRef,
  //     // compPosition: compPositionRef,
  //     productLaunches: productLaunchesRef,
  //     patentsIp: patentsIpRef,
  //     technologyCapability: technologyCapabilityRef,
  //     customerValueProposition: customerValuePropositionRef,
  //     strategicRiskMatrix: strategicRiskMatrixRef,
  //     rdSpendEstimates: rdSpendEstimatesRef,
  //     rdFocus: rdFocusRef,
  //     innovationTheme: innovationThemeRef,
  //   };

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // }, [activeSubKey]);

  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;
    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       const scrollPosition = window.scrollY + 120; // offset to trigger slightly earlier
  //       let currentKey = null;

  //       Object.entries(sectionMap).forEach(([key, ref]) => {
  //         if (!ref.current) return;
  //         const sectionTop = ref.current.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           currentKey = key;
  //         }
  //       });

  //       // update parent only if different
  //       if (currentKey && currentKey !== activeSubKey) {
  //         setActiveSubKey(currentKey);
  //       }
  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   // trigger once on mount to set correct nav if already scrolled
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [activeSubKey, setActiveSubKey]);

  useEffect(() => {
    let scrollTimeout = null;
    let ticking = false;

    const handleScroll = () => {
      if (programmaticScrollRef.current) return; // ignore programmatic scrolls
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        // Clear previous timeout (debounce)
        if (scrollTimeout) clearTimeout(scrollTimeout);

        // Wait until user stops scrolling for 200ms
        scrollTimeout = setTimeout(() => {
          const scrollPosition = window.scrollY + 120; // offset for header, etc.
          let currentKey = null;

          Object.entries(sectionMap).forEach(([key, ref]) => {
            if (!ref.current) return;
            const sectionTop = ref.current.offsetTop;
            const sectionHeight = ref.current.offsetHeight;

            // Check if scroll is within this section
            if (
              scrollPosition >= sectionTop &&
              scrollPosition < sectionTop + sectionHeight
            ) {
              currentKey = key;
            }
          });

          // update nav only if different
          if (currentKey && currentKey !== activeSubKey) {
            setActiveSubKey(currentKey);
          }
        }, 200); // change nav only after 200ms of no scrolling

        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // run once on mount
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  const { clientName, competitorName } = useParams();
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [competitivePositionAnalysis, setCompetitivePositionAnalysis] =
    useState([]);
  const [productLaunchesRelatedActivity, setProductLaunchesRelatedActivity] =
    useState([]);
  const [patentsIpActivity, setPatentsIpActivity] = useState([]);
  const [technologyCapabilityAssessment, setTechnologyCapabilityAssessment] =
    useState([]);
  const [valuePropositionAnalysis, setValuePropositionAnalysis] = useState([]);
  const [strategicRiskMatrix, setStrategicRiskMatrix] = useState([]);
  const [innovatonThemeRadar, setInnovatonThemeRadar] = useState([]);
  const [rAndDSpendEstimates, setRAndDSpendEstimates] = useState([]);
  const [portfolioData, setPortfolioData] = useState([]);
  const [totalRAndDSpend, setTotalRAndDSpend] = useState([]);

  const [productInnovationDataCheck, setProductInnovationDataCheck] = useState({
    hasInsightSummaryData: true,
    hasProductInnovationSolutionsData: true,
    // hasCompPositionData : true,
    hasProductLaunchesData: true,
    hasPatentsIpData: true,
    hasTechnologyCapabilityData: true,
    hasCustomerValuePropositionData: true,
    hasStrategicRiskMatrixData: true,
    hasRdSpendEstimatesData: true,
    hasRdFocusData: true,
    hasInnovationThemeData: true,
  });

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  const dispatch = useDispatch();
  const { loading, data, error } = useSelector(
    (state) => state.competitorProfileV3Reducer
  );

  // const v3Data = useSelector((state) => state.competitorProfileV3Reducer);

  const formData = {
    dimension: "ProductInnovation",
    client: clientName ?? "HB Fuller",
    company: competitorName ?? "Tailored Chemical Products",
  };

  useEffect(() => {
    // dispatch(submitCompetitorProfileRequest("ProductInnovation"));
    dispatch(submitCompetitorProfileV3Request(formData));
  }, []);

  // useEffect(() => {
  //   setPagePositives([
  //     `${
  //       competitorName ?? "Tailored Chemical Products"
  //     } grew >10% YoY in surgical supply and home health segments`,
  //     "Strong vertical integration with private-label manufacturing",
  //     "Launched >40 products in infection prevention and diagnostics since 2022",
  //     "Expanded PPE and kit portfolio in surgical and isolation categories",
  //     "Key partnerships with IDNs, ASCs, and long-term care chains",
  //     "Invested in RFID-enabled inventory systems for LTC/OR",
  //     "High post-acute market share in SNFs and rehab centers",
  //   ]);
  //   setPageNegatives([
  //     `${
  //       competitorName ?? "Tailored Chemical Products"
  //     }’s innovation is primarily focused on surgical kits and orthopedics-related consumables, with limited diversification into adjacent high-value procedural areas such as cardiology or oncology.`,
  //     `${
  //       competitorName ?? "Tailored Chemical Products"
  //     }’s clinical software offerings remain utility-focused (e.g., preference card tools), lacking broader AI-powered analytics or predictive insights that competitors are beginning to deliver.`,
  //     `Despite expanding in DTC home health, ${
  //       competitorName ?? "Tailored Chemical Products"
  //     } lacks smart replenishment and engagement models to drive recurring revenue and loyalty.`,
  //   ]);
  //   setPageSoWhat([]);
  // }, []);

  useEffect(() => {
    const tempCompetitivePositionAnalysis = getAllSubdimensionMatches(
      data,
      "Competitive Position Analysis"
    );
    setCompetitivePositionAnalysis(tempCompetitivePositionAnalysis);

    const tempPortfolioData = getAllSubdimensionMatches(
      data,
      "Product & Solution Portfolio"
    );
    setPortfolioData(tempPortfolioData);

    const tempProductLaunchesRelatedActivity = getAllSubdimensionMatches(
      data,
      "Product Launches & Related Activities"
    );
    setProductLaunchesRelatedActivity(tempProductLaunchesRelatedActivity);
    const tempPatentsIpActivity = getAllSubdimensionMatches(
      data,
      "Patents & IP Activity"
    );
    setPatentsIpActivity(tempPatentsIpActivity);
    const tempTechnologyCapabilityAssessment = getAllSubdimensionMatches(
      data,
      "Technology Capability Assessment"
    );
    setTechnologyCapabilityAssessment(tempTechnologyCapabilityAssessment);
    const tempValuePropositionAnalysis = getAllSubdimensionMatches(
      data,
      "Customer Value Proposition Analysis"
    );
    setValuePropositionAnalysis(tempValuePropositionAnalysis);
    const tempStrategicRiskMatrix = getAllSubdimensionMatches(
      data,
      "Strategic Risk Matrix"
    );
    setStrategicRiskMatrix(tempStrategicRiskMatrix);
    const tempInnovatonThemeRadar = getAllSubdimensionMatches(
      data,
      "Innovation Theme Radar"
    );
    setInnovatonThemeRadar(tempInnovatonThemeRadar);
    const tempRAndDSpendEstimates = getRnDSpendLineChartData(data);
    if (tempRAndDSpendEstimates && tempRAndDSpendEstimates.length > 0) {
      setRAndDSpendEstimates(tempRAndDSpendEstimates);
    }

    const tempTotalRAndSpend = getAllSubdimensionMatches(
      data,
      "R&D Spend Estimates"
    );
    setTotalRAndDSpend(tempTotalRAndSpend);

    const { positive, negative, sowhat } = getCompProfilePageInsights(data);
    setPagePositives(formatBoldText(positive) || []);
    setPageNegatives(formatBoldText(negative) || []);
    setPageSoWhat(formatBoldText(sowhat) || []);

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE

    const newCheck = {
      hasInsightSummaryData:
        hasData(positive) || hasData(negative) || hasData(sowhat),
      hasProductInnovationSolutionsData: hasData(tempPortfolioData),
      hasProductLaunchesData: hasData(tempProductLaunchesRelatedActivity),
      hasPatentsIpData: hasData(tempPatentsIpActivity),
      hasTechnologyCapabilityData: hasData(tempTechnologyCapabilityAssessment),
      hasCustomerValuePropositionData: hasData(tempValuePropositionAnalysis),
      hasStrategicRiskMatrixData: hasData(tempStrategicRiskMatrix),
      hasRdSpendEstimatesData: hasData(tempRAndDSpendEstimates),
      hasRdFocusData: hasData(tempTotalRAndSpend),
      hasInnovationThemeData: hasData(tempInnovatonThemeRadar),
    };

    // 2. Update state once
    setProductInnovationDataCheck(newCheck);

    // 3. Notify parent/tabs for each key
    Object.keys(newCheck).forEach((key) => {
      // Map internal key to the key expected by dataReportCheck
      const reportKeyMap = {
        hasInsightSummaryData: "insightSummary",
        hasProductInnovationSolutionsData: "productInnovationSolutions",
        hasProductLaunchesData: "productLaunches",
        hasPatentsIpData: "patentsIp",
        hasTechnologyCapabilityData: "technologyCapability",
        hasCustomerValuePropositionData: "customerValueProposition",
        hasStrategicRiskMatrixData: "strategicRiskMatrix",
        hasRdSpendEstimatesData: "rdSpendEstimates",
        hasRdFocusData: "rdFocus",
        hasInnovationThemeData: "innovationTheme",
      };
      dataReportCheck(reportKeyMap[key], newCheck[key]);
    });

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasInsightSummaryData: !!(positive || negative || sowhat),
    // }));

    // dataReportCheck(
    //   "insightSummary",
    //   productInnovationDataCheck.hasInsightSummaryData
    // );

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasProductInnovationSolutionsData: !!portfolioData,
    // }));

    // dataReportCheck(
    //   "productInnovationSolutions",
    //   productInnovationDataCheck.hasProductInnovationSolutionsData
    // );

    // // setProductInnovationDataCheck((prevState) => ({
    // //   ...prevState,
    // //   hasCompPositionData: !!compPosition,
    // // }));

    // // dataReportCheck(
    // //   "compPosition",
    // //   productInnovationDataCheck.hasCompPositionData
    // // );

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasProductLaunchesData: !!productLaunchesRelatedActivity,
    // }));

    // dataReportCheck(
    //   "productLaunches",
    //   productInnovationDataCheck.hasProductLaunchesData
    // );

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasPatentsIpData: !!patentsIpActivity,
    // }));

    // dataReportCheck("patentsIp", productInnovationDataCheck.hasPatentsIpData);

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasTechnologyCapabilityData: !!technologyCapabilityAssessment,
    // }));

    // dataReportCheck(
    //   "technologyCapability",
    //   productInnovationDataCheck.hasTechnologyCapabilityData
    // );

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasCustomerValuePropositionData: !!customerValuePropositionRef,
    // }));

    // dataReportCheck(
    //   "customerValueProposition",
    //   productInnovationDataCheck.hasCustomerValuePropositionData
    // );

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasStrategicRiskMatrixData: !!strategicRiskMatrix,
    // }));

    // dataReportCheck(
    //   "strategicRiskMatrix",
    //   productInnovationDataCheck.hasStrategicRiskMatrixData
    // );

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasRdSpendEstimatesData: !!rAndDSpendEstimates,
    // }));

    // dataReportCheck(
    //   "rdSpendEstimates",
    //   productInnovationDataCheck.hasRdSpendEstimatesData
    // );

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasRdFocusData: !!totalRAndDSpend,
    // }));

    // dataReportCheck("rdFocus", productInnovationDataCheck.hasRdFocusData);

    // setProductInnovationDataCheck((prevState) => ({
    //   ...prevState,
    //   hasInnovationThemeData: !!innovatonThemeRadar,
    // }));

    // dataReportCheck(
    //   "innovationTheme",
    //   productInnovationDataCheck.hasInnovationThemeData
    // );
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  }, [data]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HANDLE SCROLL FROM SEARCH (from parent via scrollTarget)
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!scrollTarget) return;

  //   // Don't scroll if data is still loading
  //   if (loading) {
  //     console.log("Waiting for data to load...");
  //     return;
  //   }

  //   const targetKey = scrollTarget.key;
  //   const sectionRef = sectionMap[targetKey];

  //   const scrollToSection = () => {
  //     if (!sectionRef?.current) {
  //       requestAnimationFrame(scrollToSection);
  //       return;
  //     }

  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const element = sectionRef.current;
  //     const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);
  //   };

  //   // Give extra time for skeleton to disappear and content to render
  //   const timer = setTimeout(() => {
  //     requestAnimationFrame(scrollToSection);
  //   }, 1200); // Increase this if staticDataLoading timeout is 1000ms

  //   return () => clearTimeout(timer);
  // }, [scrollTarget, loading]); // ADD staticDataLoading to deps
  useEffect(() => {
    if (!scrollTarget || loading) return;

    const timer = setTimeout(() => {
      scrollToSection(scrollTarget.key);
    }, 900); // wait for skeleton + render

    return () => clearTimeout(timer);
  }, [scrollTarget, loading]);

  // +++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div className="product_innovation_wrapper">
      <div className="product_innovation_headblock">
        <div className="product_innovation_subheadblock">
          <h5 className="product_innovation_head">
            Product & Innovation -{" "}
            {competitorName ?? "Tailored Chemical Products"}
          </h5>
          <p className="product_innovation_para">
            Portfolio evolution, launch momentum, innovation themes, and
            patents.
          </p>
        </div>
        <div className="product_innovation_btn_block">
          <TopRightActionLinks actions={actions} />
        </div>
      </div>

      {/* {clientName !== "Oracle Corporation" && */}
      {
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
          productInnovationDataCheck.hasInsightSummaryData && (
            <div ref={summaryRef}>
              <InsightBlock
                title={""}
                overview={""}
                actions={[]}
                pagePositives={pagePositives}
                pageNegatives={pageNegatives}
                pageSoWhat={pageSoWhat}
              />
            </div>
          )
      }

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== "Oracle Corporation" &&
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        productInnovationDataCheck.hasProductInnovationSolutionsData && (
          <div ref={productSolutionsRef}>
            <ProductAndSolutionsPortfolio
              portfolioData={portfolioData}
              compView={compView}
            />
          </div>
        )
      )}

      {/* <div ref={compPositionRef}>
        <CompetitivePositionAnalysis
          competitivePositionAnalysis={competitivePositionAnalysis}
        />
      </div> */}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== "Oracle Corporation" &&
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        productInnovationDataCheck.hasProductLaunchesData && (
          <div ref={productLaunchesRef}>
            <ProductLaunchesAndRelatedActivities
              productLaunchesRelatedActivity={productLaunchesRelatedActivity}
              compView={compView}
            />
          </div>
        )
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== "Oracle Corporation" &&
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        productInnovationDataCheck.hasPatentsIpData && (
          <div ref={patentsIpRef}>
            <PatentsAndIpActivity
              patentsIpActivity={patentsIpActivity}
              compView={compView}
            />
          </div>
        )
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== "Oracle Corporation" &&
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        productInnovationDataCheck.hasTechnologyCapabilityData && (
          <div ref={technologyCapabilityRef}>
            <TechnologyCapabilityAssessment
              technologyCapabilityAssessment={technologyCapabilityAssessment}
              compView={compView}
            />
          </div>
        )
      )}

      {/* <div ref={customerValuePropositionRef}>
        <ValuePropositionAnalysis
          valuePropositionAnalysis={valuePropositionAnalysis}
        />
      </div> */}

      {/* <div ref={strategicRiskMatrixRef}>
        <StrategicRiskMatrix strategicRiskMatrix={strategicRiskMatrix} />
      </div> */}

      {/* +++++++++++++++++++++++++++ */}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        productInnovationDataCheck.hasRdSpendEstimatesData && (
          <div className="rdspend_estimates_wrapper" ref={rdSpendEstimatesRef}>
            <div className="rdspend_estimates_headblock">
              <div className="rdspend_estimates_subheadblock">
                <h5 className="rdspend_estimates_head">R&D Spend Estimates</h5>
                {/* <p className="rdspend_estimates_para">
                Year-wise R&D investment by{" "}
                {competitorName ?? "Tailored Chemical Products"} (in B$) and
                focus areas with strategic priorities.
              </p> */}
                <p className="rdspend_estimates_para">
                  Year-wise R&D investment by{" "}
                  {competitorName ?? "Tailored Chemical Products"} and focus
                  areas with strategic priorities.
                </p>
              </div>
              <div className="rdspend_estimates_btn_block">
                <TopRightActionLinks actions={actions} />
              </div>
            </div>
            <div className="rdspend_estimates_block">
              <LineChart chartData={rAndDSpendEstimates} />
            </div>
          </div>
        )
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        productInnovationDataCheck.hasRdFocusData && (
          <div ref={rdFocusRef}>
            <TotalRAndDSpend rAndDSpendEstimates={totalRAndDSpend} />
          </div>
        )
      )}

      {/* <div className="total_rd_wrapper mb-4">
        <h5 className="total_rd_head">
          Total R&D Spend (2019–2023): $2.23B | CAGR: 11.5%
        </h5>
        <div className="total_rd_block">
          <div className="row">
            <div className="col-md-6">
              <div className="total_rd_card_block">
                <Card className="total_rd_card">
                  <Card.Header className="total_rd_card_header">
                    Featured
                  </Card.Header>
                  <Card.Body className="total_rd_card_body">
                    <div className="top_area_block">
                      <h5 className="top_area_head">
                        Wound Innovation – $620M
                      </h5>
                      <p className="top_area_para">
                        Advanced foam, hydrogel, and silver-based dressing
                        innovations.
                      </p>
                    </div>
                    <div className="top_area_block">
                      <h5 className="top_area_head">
                        Wound Innovation – $620M
                      </h5>
                      <p className="top_area_para">
                        Advanced foam, hydrogel, and silver-based dressing
                        innovations.
                      </p>
                    </div>
                    <div className="top_area_block">
                      <h5 className="top_area_head">
                        Wound Innovation – $620M
                      </h5>
                      <p className="top_area_para">
                        Advanced foam, hydrogel, and silver-based dressing
                        innovations.
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <div className="col-md-6">
              <div className="total_rd_card_block">
                <Card className="total_rd_card">
                  <Card.Header className="total_rd_card_header">
                    Current & Emerging Priorities
                  </Card.Header>
                  <Card.Body className="total_rd_card_body">
                    <div className="top_area_block">
                      <h5 className="top_area_head">
                        Wound Innovation – $620M
                      </h5>
                      <p className="top_area_para">
                        Advanced foam, hydrogel, and silver-based dressing
                        innovations.
                      </p>
                    </div>
                    <div className="top_area_block">
                      <h5 className="top_area_head">
                        Wound Innovation – $620M
                      </h5>
                      <p className="top_area_para">
                        Advanced foam, hydrogel, and silver-based dressing
                        innovations.
                      </p>
                    </div>
                    <div className="top_area_block">
                      <h5 className="top_area_head">
                        Wound Innovation – $620M
                      </h5>
                      <p className="top_area_para">
                        Advanced foam, hydrogel, and silver-based dressing
                        innovations.
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* +++++++++++++++++++++++++++ */}
      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        productInnovationDataCheck.hasInnovationThemeData && (
          <div ref={innovationThemeRef}>
            <InnovationThemeRadar
              innovatonThemeRadar={innovatonThemeRadar}
              compView={compView}
            />
          </div>
        )
      )}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - R&D Spend
                    Estimates
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={"R&D Spend Estimates"} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default ProfileProductInnovation;
